function searchFilter(searchElOriginal, keyword, findEl) {
    // // console.log(keyword);
    return searchElOriginal.filter((el) => {
        if (findEl && el[findEl]) { // findEl 속성이 있고, 해당 객체에 그 속성이 존재하는 경우
            return el[findEl].toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
        } else if (typeof el === 'string') { // el이 문자열인 경우, 직접 비교
            return el.toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
        }
        return false; // 그 외의 경우는 false 반환
    });
}

export { searchFilter };

// 사용법 예제: src/searchExComponent.vue